import { forwardRef } from 'react'

import { Input, Label } from '@/components/ui'
import { cn, slugify } from '@/utils'

export interface TextFieldProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string
  error?: string | null
  helpText?: string
  inputClassName?: string
}

const TextField = forwardRef<HTMLInputElement, TextFieldProps>(
  (
    { id, label, className, inputClassName, error, helpText, ...props },
    ref,
  ) => {
    const _id = id ? id : `${slugify(label)}_${crypto.randomUUID()}`

    return (
      <div className={cn('space-y-2', className)}>
        <Label htmlFor={_id} className="text-sm font-medium">
          {label}
        </Label>
        <Input
          id={_id}
          className={cn('h-10', inputClassName)}
          {...props}
          ref={ref}
        />
        {error && <p className="text-xs font-semibold text-red-500">{error}</p>}
        {helpText && (
          <p className="text-xs text-muted-foreground leading-relaxed">
            {helpText}
          </p>
        )}
      </div>
    )
  },
)
TextField.displayName = 'TextField'

export { TextField }
